import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { getAuthToken } from "../../utils/Authentication/handleAPIAuthToken";
import Loader from "../shared/loader/Loader";
import ErrorPage from "../shared/errorPage/ErrorPage";
import { ResetUserAccount } from "../../actions/UserAccount";
import { setLocalSessionData, getLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { routePath, WebCustomerRoutePaths } from "../../constants/Routes";
import { LOCALSESSIONDATAKEYS, SIGNUPTYPE } from "../../constants/AppConstants";
import i18next from "i18next";
import { getLangCode } from "../../utils/Internationalization/handleAppInternationalization";
import { AuthenticateUserByExternalRedirect } from "../../constants/AppMethod";
import { handleLogin } from "../../actions/Authentication/Auth_SignIn_SignUp";
import { FetchUserAccount } from "../../actions/UserAccount"

const Profile = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { RouterLinkStateProp, signupType } = props;
    const { inProgress, accounts } = useMsal();
    const authToken = getAuthToken();
    const UserAuthInfo = useSelector(state => state.App_SignIn_Auth);
    const UserAccount = useSelector((state) => state.UserAccount);
    const [callGetBOCUserIdByADB2CID, setCallGetBOCUserIdByADB2CID] = useState(null);
    const adb2cId = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
    var userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    var deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const [callUserAccount, setCallUserAccount] = useState(true);
    const {
        userDeviceList_error,
        userDeviceList_success
    } = useSelector(state => state.ROOTREDUCER_RTK.GetUserEnrolledDevicesService);

    const handleSignUpType = (redirectPage) => {
        if (redirectPage === WebCustomerRoutePaths.SELECT_PRINTER) {
            setLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE, SIGNUPTYPE.WEB);
        }
    }

    useEffect(() => {
        // Dispatch event after setting Bearer token immediately after login
        if (inProgress === InteractionStatus.None && !authToken) {
            setLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID, accounts[0].idTokenClaims.sub);
            setCallGetBOCUserIdByADB2CID(true);
        }

        if (RouterLinkStateProp === "SUBSCRIPTION_NETWORK_ERR_VALIDATION") {
            setCallGetBOCUserIdByADB2CID(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inProgress]);

    if (callGetBOCUserIdByADB2CID) {
        /**
         * Handles multiple API calls within a single action file for user authentication.
         * This method manages the login process by dispatching appropriate actions.
         * Below API's are triggered
         *  - User/GetUserBocIdByADB2CId
         *  - shared/User/GetUserRole
         *  - shared/UserEnrolledDevices/GetUserEnrolledDevices
         */
        dispatch(handleLogin(signupType, deviceId))
        setCallGetBOCUserIdByADB2CID(false);
        return <Loader></Loader>
    }

    /** Display error page when user signin fails */
    if (UserAuthInfo.error) {
        return <ErrorPage errorInfo={UserAuthInfo.error}></ErrorPage>
    }

    /** Retry fetching UserId by redirecting to shnelong url 
     * when userid is not returned by GetUserBocIdByADB2CId API*/
    if (UserAuthInfo.success && UserAuthInfo.BOC_NO_UserID_Err) {
        AuthenticateUserByExternalRedirect(routePath.SHENLONG_REDIRECT);
    }

    /** Display error page when GetUserEnrolledDevices fails */
    if (userDeviceList_error) {
        return <ErrorPage errorInfo={userDeviceList_error}></ErrorPage>
    }

    /** Call GetUserAccount API only after 
     * - User BOC Id is returned by GetUserBOCIdByADB2CID API
     * - SignIn_Auth is successful for non-customer roles (like Admin, CSAgent etc)
     * - SignIn_Auth and GetUserEnrolledDevices API are both successful for customer role*/
    if (callUserAccount &&
        (UserAuthInfo.success && !UserAuthInfo.BOC_NO_UserID_Err) &&
        ((UserAuthInfo.success && UserAuthInfo.IsNonCustomerRole) ||
            (UserAuthInfo.success && !UserAuthInfo.IsNonCustomerRole && userDeviceList_success))) {
        dispatch(FetchUserAccount(adb2cId, userId, deviceId, signupType));
        setCallUserAccount(false);
    }

    /** Redirect to select printer page when GetUserAccount fails */
    if (UserAccount.error) {
        if (UserAccount.redirectToLandingPage) {
            dispatch(ResetUserAccount());
            handleSignUpType(UserAccount.redirectPage);
            history.push(UserAccount.redirectPage);
        }
        else {
            return <ErrorPage errorInfo={UserAccount.error}></ErrorPage>
        }
    }

    /** Redirect to respective Signin or SignUp journey if GetUserAccount API is successful */
    if (UserAccount.success) {
        i18next.changeLanguage(getLangCode());
        return <Redirect to={{ pathname: routePath.ROLE_REDIRECTION, state: { "RouterLinkStateProp": RouterLinkStateProp } }}></Redirect>
    }

    if (authToken && inProgress === InteractionStatus.None && callGetBOCUserIdByADB2CID === null) {
        return <Redirect to={{ pathname: routePath.ROLE_REDIRECTION, state: { "RouterLinkStateProp": RouterLinkStateProp } }}></Redirect>
    }

    return (
        <Loader></Loader>
    )
}

export default Profile;